function isSignedIn() {
  const signedInHash = localStorage.getItem('__psi');

  if (!signedInHash) {
    return false;
  }

  if (signedInHash == getSignedInHash('app-require-button-click', '1')) {
    return true;
  }

  let signedIn = false;
  $.each(settings.users, function (username, password) {
    // console.log(username, password, getSignedInHash(username, password), signedInHash);
    if (getSignedInHash(username, password) === signedInHash) {
      signedIn = true;
      return false;
    }
  });

  return signedIn;
}

function getSignedInHash(username, password) {
  return CryptoJS.MD5(username + password).toString();
}
